// extracted by mini-css-extract-plugin
export default {"wrapper":"j1pNJlBmOAi0NC1LgmyF","charts":"ddM_sgJlgbZCeSRJbGzU","periodsList":"HCfWCvLhg7WFhZepD5I5"};